<template>
	<div>
    <v-delete-dialog
      v-if="showingAlert"
      @close="showingAlert = false"
      @confirm="onRemoveUser"
      @cancel="cancelDelete"
      :errorMessage="errorMessage">
    </v-delete-dialog>

    <d-alert show>
      <i class="fa fa-info"></i>
      <span>You can add an existing user by searching in the user dropdown. If the user does not exist you can add a new user by submitting a new email address</span>
    </d-alert>

    <d-row>
      <d-col lg="12" >
        <v-feedback :bus="bus"></v-feedback>
      </d-col>
    </d-row>

    <d-row class="mt-3">
      <d-col>
        <h5>Add User</h5>
      </d-col>
    </d-row>

    <d-row class="mb-3" >
      <d-col lg="1" style="display: flex; align-items: center;"><strong>Users</strong></d-col>
      <d-col lg="3">
        <multiselect :value="allUsers.find( _ => _.id === userID )"
                     label="email"
                     @input="userID = $event && $event.id"
                     :options="allUsers"/>
      </d-col>
      <d-col>
        <d-button @click="onSubmit" class="button" v-if="userID != null && showingAlert == false">Add</d-button>
      </d-col>
    </d-row>

    <d-row class="mb-5" >
      <d-col lg="1" style="display: flex; align-items: center;"><strong>New user</strong></d-col>
      <d-col lg="3">
        <d-input v-model="fields.email" placeholder="Email Address" :class="{ 'is-invalid': hasError('email') }" />
        <span class="invalid-feedback" v-if="hasError('email')">{{ getError('email') }}</span>
      </d-col>
      <d-col>
        <d-button @click="onAddNew" class="button">Add</d-button>
      </d-col>
    </d-row>


    <d-row class="mt-3">
      <d-col>
        <h5>Overview Users</h5>
      </d-col>
    </d-row>

    <d-row class="mb-3">
      <d-col class="col-12">
        <d-card>
          <d-card-body class="p-0">
            <table class="table  mb-0">
              <thead class="bg-light ">
                <tr class="d-flex">
                  <th class="col border-0"><span>User email</span></th>
                  <th class="col-auto border-0"><span>Action</span></th>
                </tr>
              </thead>

              <tbody>
              <template v-for="user in users">
                <tr class="d-flex" scope="row">

                  <td class="col">
                    {{user.email}}
                  </td >
                  <td class="col-auto" @click="onDelete(user.id)">
                    <d-link><i class="fa fa-trash-alt"></i></d-link>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>

          </d-card-body>
        </d-card>

      </d-col>
    </d-row>

  </div>
</template>

<script>
	import Vue from "vue";
  import Multiselect from 'vue-multiselect'
  import Settings from "~/components/settings" 

  export default {
		name: "Users",

    components: {
      Multiselect,
    },

    data: function() {
      return {
        errors: [],
        fields: {
          email: ''
        },
        allUsers: [],
        userID: null,
        users: [],
        showingAlert: false,
        errorMessage: 'Do you really want to delete this user?',
        deleteId: null,
        bus: new Vue(),
      }
    },

    props: {
      parking: Object
    },

    mounted: function () {
		  this.getAllUsers();
      this.users = this.parking.members.map(item => {
        return {
          ...item.user,
        };
      });
    },

    methods: {

      hasError: function (field) {
        return this.errors.find(error => error.field === field);
      },

      getError: function (field) {
        return this.errors.find(error => error.field === field).message;
      },

		  getAllUsers: async function() {

        await this.$apollo.query({
          query: require('~/graphql/users/GetAllUsers.gql'),
        }).then( data => {

          this.allUsers = [...data.data.users]
          this.allUsers =  this.allUsers.map((item, id) => {
            let obj = {id:item.id, value:item.id, email: item.email};
            return obj;
          });
       

        }).catch(err => {
          this.bus.$emit('getUsers', {type: 'warning', message: 'Not able to fetch the users'})
          throw err;
        });

      },

      onSubmit: async function() {

		    if (this.userID === null) return;

        const data = await this.$apollo.mutate({
          mutation: require('~/graphql/users/AddUser.gql'),
          variables: {
            id: this.userID,
            providerID: this.parking.id
          }
        }).then( data => {
          if (data.data.addProviderMember.success) {
            window.location.reload(true);
          }
        })
      },


      onAddNew: async function() {
        this.errors = [];
        this.errors = Settings.hasValidationErrors(this.fields, this.errors)
        if (this.errors.length > 0) return;

        const variables = {
          email: this.fields.email,
          locale: this.parking.locale
        }

        try {
          const data = this.$apollo.query({
            query: require('~/graphql/users/CreateUser.gql'), variables, fetchPolicy: 'no-cache'
          }).then(data => {
            const res = data.data.createUser
            if (res.success) {
              this.bus.$emit('submitData', {type: 'warning', message: `An e-mail invite has been sent to ${res.user.email}`})
              this.userID = res.user.id
              this.onSubmit();
            } else {
              this.bus.$emit('submitData', {type: 'warning', message: 'Something went wrong, the user has NOT been invited'})
              this.submitting = false;
            }
          })
        } catch (error) {
          this.bus.$emit('submitData', {type: 'warning', message: 'Error: ' + error})
          this.submitting = false;
        }
      },

      onDelete: function(id) {
        this.userID = id
        this.showingAlert = true;
      },

      cancelDelete() {
        this.showingAlert = false;
        this.userID = null;
      },

      onRemoveUser: async function() {

        const data = await this.$apollo.mutate({
          mutation: require('~/graphql/users/DeleteUser.gql'),
          variables: {
            id: this.userID,
            providerID: this.parking.id
          }
        }).then( data => {
          if (data.data.removeProviderMember.success) {
            window.location.reload(true);
          }
        })
      },

      isDirty: () => false,
    },



	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
